import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonBase, Icon, Stack, Typography,
} from '@mui/material';
import Close from '@mui/icons-material/Close';
import { openInBrowser } from '../../../helpers/broswer';

const styles = {
  button: {
    background: '#E8EEF9',
    color: '#03295F',
    minHeight: '34px',
    fontSize: '13px',
    fontWeight: 700,
    paddingLeft: '8px',
    paddingRight: '20px',
    marginLeft: '16px',
    marginRight: '16px',
    marginBottom: '16px',
    borderRadius: '8px',
  },
  buttonText: {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(15ch + 10vw)',
  },
  buttonImg: {
    height: '21px',
    width: '21px',
  },
};

const PdfIndicator = ({
  attachment, overrideStyle = {}, overrideTextStyle = {}, editable = false, onDelete = () => {},
}) => {
  const { uri, media, name } = attachment || {};

  const isPdf = media?.type === 'pdfs';
  const mediaUrl = media?.media_url;

  const viewPdf = async (e) => {
    e.stopPropagation();
    if (!uri && !(isPdf && mediaUrl)) {
      return;
    }
    await openInBrowser(uri || mediaUrl);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete();
    }
  };

  const buttonStyles = {
    ...styles.button,
    ...overrideStyle,
  };

  const textStyles = {
    ...styles.buttonText,
    ...overrideTextStyle,
  };

  return (
    <ButtonBase onClick={viewPdf} sx={buttonStyles} id="pdf-indicator-button">
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Icon>
          <img src="/assets/icon/file-attachment.svg" alt="file icon" style={styles.buttonImg} />
        </Icon>
        <Typography sx={textStyles}>{name || 'Pdf attachment'}</Typography>
        {editable && (
          <ButtonBase onClick={handleDeleteClick} sx={{ position: 'absolute', right: 10 }}>
            <Close />
          </ButtonBase>
        )}
      </Stack>
    </ButtonBase>
  );
};

PdfIndicator.propTypes = {
  attachment: PropTypes.shape({
    name: PropTypes.string,
    s3_key: PropTypes.string,
    uri: PropTypes.string,
    media: PropTypes.shape({
      type: PropTypes.string,
      media_url: PropTypes.string,
    }),
  }).isRequired,
  overrideStyle: PropTypes.shape({}),
  overrideTextStyle: PropTypes.shape({}),
  editable: PropTypes.bool,
  onDelete: PropTypes.func,
};


export default PdfIndicator;
